import React from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import SaleVoucherRAForm from './SaleVoucherRAForm';

/** Read-only view of one voucher. Reuses the form's panels (all disabled) instead of a second layout. */
const SaleVoucherRAView = () => {
    const { voucherNo } = useParams();
    const [searchParams] = useSearchParams();
    const financialYear = searchParams.get('financialYear') || undefined;
    return <SaleVoucherRAForm key={`view-${voucherNo}-${financialYear || ''}`} mode="view" voucherNo={voucherNo} financialYear={financialYear} />;
};

export default SaleVoucherRAView;
